/* eslint-disable @stencil-community/own-methods-must-be-private */
/* eslint-disable @stencil-community/own-props-must-be-private */
import { Component, Host, h, Prop, State, Watch, Event, EventEmitter, Fragment, Method } from '@stencil/core';
import { LabelParser } from '../sew-ws-header/helpers/labels.helpers';
import { Labels } from '../sew-ws-header/types/labels.types';
import { SewUser } from '@sew/auth-service';
import { User } from '../sew-ws-header/types/user.types';

@Component({
    tag: 'sew-ws-login',
    styleUrl: 'sew-ws-login.scss',
    shadow: true,
})
export class SewWsLogin {
    @Event() login: EventEmitter;
    @Event() logout: EventEmitter;

    @Prop() country: string;
    @Prop({ attribute: 'baseUrl' }) baseUrl: string;
    @Prop() language: string;
    @Prop() labels: Labels;
    @Prop() user: SewUser | User | null;
    @Prop() nameError = false;
    @Prop() passwordError = false;

    @State() private labelParser: LabelParser;

    @Watch('labels')
    public watchLabels(): void {
        this.labelParser = new LabelParser(this.labels);
    }

    @Method()
    async setLoginError(): Promise<void> {
        this.nameError = true;
        this.passwordError = true;
    }

    public componentWillLoad(): void {
        this.labelParser = new LabelParser(this.labels);
    }

    private handleLogin(): void {
        this.login.emit();
    }

    private handleLogout(): void {
        this.logout.emit();
    }

    private getUserLoggedInTemplate() {
        return (
            <Fragment>
                <h3>
                    {this.labelParser
                        .getLabel('CMS_HEADER_LOGIN_GREETING')
                        .replace(
                            '{{userName}}',
                            `${(this.user as SewUser).firstName || (this.user as User).firstname} ${(this.user as SewUser).lastName || (this.user as User).lastname}`
                        )}
                </h3>
                {this.country && this.language && (
                    <sew-ws-linklist>
                        <sew-ws-link>
                            <a href={`${this.baseUrl}/os/c/main.do?viewset=MY_ACCOUNT&ma_at=3`}>
                                {this.labelParser.getLabel('CMS_HEADER_LOGIN_OPTIONS_SETTINGS')}
                            </a>
                        </sew-ws-link>
                        <sew-ws-link>
                            <a
                                href={`${
                                    this.baseUrl
                                }/os/c/main.do?viewset=MY_ACCOUNT&country=${this.country.toUpperCase()}&language=${this.language.toLowerCase()}`}
                            >
                                {this.labelParser.getLabel('CMS_HEADER_LOGIN_PERSONAL_DATA')}
                            </a>
                        </sew-ws-link>
                        <sew-ws-protected-link
                            os={false}
                            login-required={true}
                            role-required="PROJECT_ROOMS"
                            authorization-required={true}
                        >
                            <a href={`${this.baseUrl}/share_preauth/`}>
                                {this.labelParser.getLabel('CMS_HEADER_LOGIN_PROJECT_ROOMS')}
                            </a>
                        </sew-ws-protected-link>
                        <sew-ws-protected-link
                            os={false}
                            login-required={true}
                            role-required="USER_ADMINISTRATION"
                            authorization-required={true}
                        >
                            <a
                                href={`${
                                    this.baseUrl
                                }/os/c/main.do?viewset=user_admin&country=${this.country.toUpperCase()}&language=${this.language.toLowerCase()}`}
                            >
                                {this.labelParser.getLabel('CMS_HEADER_LOGIN_USER_ADMIN')}
                            </a>
                        </sew-ws-protected-link>
                    </sew-ws-linklist>
                )}
                <sew-ws-button>
                    <button onClick={() => this.handleLogout()}>
                        {this.labelParser.getLabel('CMS_HEADER_LOGIN_END')}
                    </button>
                </sew-ws-button>
            </Fragment>
        );
    }

    private generateLoginComponent() {
        return (
            <form>
                <div class="headline">{this.labelParser.getLabel('CMS_HEADER_LOGIN_HEADLINE')}</div>
                <sew-ws-button id="btn-header-login">
                    <button type="button" onClick={() => this.handleLogin()}>
                        {this.labelParser.getLabel('CMS_HEADER_LOGIN_START')}
                    </button>
                </sew-ws-button>
                {this.country && this.language && (
                    <sew-ws-linklist>
                        <sew-ws-link id="link-header-pw_forgot">
                            <a
                                href={`${
                                    this.baseUrl
                                }/os/c/main.do?addon=USER&viewset=PASSWORD_FORGOT_MAIL&country=${this.country.toUpperCase()}&language=${this.language.toLowerCase()}`}
                            >
                                {this.labelParser.getLabel('CMS_HEADER_LOGIN_FORGOT_PASSWORD')}
                            </a>
                        </sew-ws-link>
                        <sew-ws-link id="link-header-reg_initial">
                            <a
                                href={`${
                                    this.baseUrl
                                }/os/c/main.do?viewset=REGISTRATION_INITIAL&country=${this.country.toUpperCase()}&language=${this.language.toLowerCase()}`}
                            >
                                {this.labelParser.getLabel('CMS_HEADER_LOGIN_REGISTER')}
                            </a>
                        </sew-ws-link>
                    </sew-ws-linklist>
                )}
            </form>
        );
    }

    render() {
        return (
            <Host>
                {!this.user && this.generateLoginComponent()}
                {this.user && this.getUserLoggedInTemplate()}
            </Host>
        );
    }
}
